import cc from "classcat"
import React from "react"

import styles from "./BudgetSummary.module.css"

import CurrencyInput from "~/common/CurrencyInput"

import { PricingModelSelection } from "~/GLOBALVARS"
import BudgetMethodSelector from "~/forms/ProjectBudgetForm/Budget/BudgetMethodSelector"
import SelectPricingModel from "~/forms/ProjectForm/SelectPricingModel"

import { BudgetMethod } from "../types"

type Props = {
  billingMethod: PricingModelSelection
  totalBudget: number
  invalid: boolean
  currency: string
  showNonBillableView: boolean
  allowBillingMethodEdit: boolean
  budgetMethod: BudgetMethod
  onChangeBillingMethod: (method: PricingModelSelection) => void
  onChangeTotalBudget?: (budget: number) => void
  onChangeBudgetMethod: (method: string) => void
}

const BudgetSummary = (props: Props) => {
  const {
    billingMethod,
    totalBudget,
    invalid = false,
    currency,
    showNonBillableView = true,
    allowBillingMethodEdit = true,
    budgetMethod,
    onChangeBillingMethod,
    onChangeTotalBudget,
    onChangeBudgetMethod,
  } = props

  return (
    <div className={styles.container}>
      <div className={styles.selectorContainer}>
        <div className={styles.selectorWrapper}>
          <div className={styles.label}>Pricing Model</div>
          <SelectPricingModel
            value={billingMethod}
            onChange={onChangeBillingMethod}
            height={40}
            fontSize={13}
            isDisabled={!allowBillingMethodEdit}
            dataTest="budget-pricing-model"
          />
        </div>
        {billingMethod.value !== "nb" && (
          <div className={styles.selectorWrapper}>
            <div className={styles.label}>Budget Method</div>
            <BudgetMethodSelector
              value={budgetMethod}
              onChange={onChangeBudgetMethod}
            />
          </div>
        )}
      </div>
      {!showNonBillableView && (
        <div className={styles.budgetWrapper}>
          <div className={cc([styles.label, invalid && styles.invalidLabel])}>
            Project Budget {invalid && "is invalid"}
          </div>
          <CurrencyInput
            name="total-budget"
            dataTest="total-budget"
            style={{ textAlign: "right" }}
            value={totalBudget}
            onChange={onChangeTotalBudget}
            currency={currency}
            height={40}
            fontSize={13}
            stepSize={1000}
            error={invalid}
            integer={true}
            selectAllOnFocus
          />
        </div>
      )}
    </div>
  )
}

export default BudgetSummary
